export default __webpack_public_path__ + "static/media/fad-preset-ba.da812380.svg";